import { styled } from 'theme';

const FormErrorMessage = styled('div', {
  // Reset
  boxSizing: 'border-box',

  // Custom
  display: 'inline-block',
  mt: '$1',
  px: '$2',
  py: '2px',
  fontSize: '$sm',
  letterSpacing: '$wide',
  color: '$red800',
  backgroundColor: '$red100',
  borderRadius: '$xs',
});

export default FormErrorMessage;
